import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { Observable } from 'rxjs/internal/Observable';
import { filter } from 'rxjs/operators';

@Injectable()
export class BroadcastService {
      private event$: Subject<BroadcastEvent> = new Subject<BroadcastEvent>();

  public next(event: BroadcastEvent) {
        this.event$.next(event);
  }

  public getEvents(...eventNames: any[]): Observable<BroadcastEvent> {
        return this.event$.asObservable()
      .pipe(filter(broadcastEvent => eventNames.indexOf(broadcastEvent.name) !== -1));
  }
}

export class BroadcastEvent {
      name: any;
  args?: any;
}